import DeliveriesSerializer from './deliveries';

export default class NotificationScheduleSerializer extends DeliveriesSerializer {
  attrs = {
    deliveryArea: {
      serialize: false,
    },
  };
}
